import { render } from "./ClientActions.vue?vue&type=template&id=30369adc&scoped=true"
import script from "./ClientActions.vue?vue&type=script&lang=js"
export * from "./ClientActions.vue?vue&type=script&lang=js"

import "./ClientActions.vue?vue&type=style&index=0&id=30369adc&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30369adc"]])

export default __exports__